module.exports = __webpack_public_path__ + "img/cat.52c1714c.svg";